import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from "react-bootstrap";
import LeaveLayout from "../../components/LeaveLayout.js";
import { LuCalendarMinus } from "react-icons/lu";
import "react-datepicker/dist/react-datepicker.css"; // Import the CSS for the date picker
import { format } from "date-fns"; // Import date-fns for date formatting
import "./leaves.css";
import axios from "axios";

export default function Leaves() {
  const [entries, setEntries] = useState(10); // Corrected state variable
  const [searchTerm, setSearchTerm] = useState("");
  const [leaves, setLeaves] = useState([]); // State to store leaves data

  // Fetch leaves when component mounts
  const fetchLeaves = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("User ID not found in session storage");
      return;
    }

    try {
      const response = await axios.get(
        `http://localhost:5544/api/leaves/user/${userId}`
      );
      console.log("Leaves fetched successfully:", response.data.leaves);
      setLeaves(response.data.leaves); // Update state with fetched leaves
    } catch (error) {
      console.error("Error fetching leaves:", error.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchLeaves(); // Fetch leaves on component mount
  }, []);

  return (
    <LeaveLayout>
      <div className="leave-header">
        <h1 className="leave-title">
          <LuCalendarMinus /> Leave
        </h1>
      </div>
      <hr />
      <div className="leave-table-container">
        <div className="entries-search-container" style={{ marginTop: 0 }}>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setEntries(10)}>
                    10
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(25)}>
                    25
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(50)}>
                    50
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(100)}>
                    100
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end search-container">
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Form>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped leave-table">
            <thead className="table-header">
              <tr className="leave-table-header">
                <th>SR</th>
                <th>Leave Type</th>
                <th>Days</th>
                <th>Description</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              {leaves.length > 0 ? (
                leaves
                  .filter((leave) =>
                    leave.leaveType.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .slice(0, entries)
                  .map((leave, index) => (
                    <tr key={leave._id}>
                      <td>{index + 1}</td>
                      <td>{leave.leaveType}</td>
                      <td>{leave.days}</td>
                      <td>{leave.reason}</td>
                      <td>{format(new Date(leave.startDate), "yyyy-MM-dd")}</td>
                      <td>{format(new Date(leave.endDate), "yyyy-MM-dd")}</td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="6">No leave records found</td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr className="leave-table-footer">
                <td>Total</td>
                <td>-</td>
                <td>{leaves.length}</td>
                <td>2</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </LeaveLayout>
  );
}
